var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRequestSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 118,
    viewBox: "0 0 138 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_678_36403)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.787 108.287a4.85 4.85 0 002.462.203 4.872 4.872 0 002.244-1.034c1.648-1.389 2.164-3.676 2.585-5.793l1.243-6.265-2.603 1.8c-1.873 1.293-3.787 2.629-5.083 4.503-1.296 1.874-1.862 4.433-.82 6.461",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.19 116.308c-.328-2.396-.665-4.823-.435-7.245.204-2.151.858-4.251 2.19-5.974a9.907 9.907 0 012.54-2.311c.253-.161.487.243.234.403a9.439 9.439 0 00-3.723 4.509c-.81 2.07-.941 4.326-.801 6.524.084 1.33.263 2.65.444 3.97a.24.24 0 01-.025.175.238.238 0 01-.138.112.233.233 0 01-.286-.163z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.548 112.463a3.592 3.592 0 003.125 1.62c1.583-.076 2.902-1.184 4.089-2.236l3.511-3.113-2.324-.111c-1.671-.081-3.386-.156-4.978.362-1.592.518-3.06 1.763-3.35 3.417",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.263 117.686c1.578-2.802 3.407-5.916 6.677-6.911a7.41 7.41 0 012.808-.291c.298.026.224.487-.074.461a6.903 6.903 0 00-4.481 1.19c-1.264.864-2.248 2.064-3.08 3.337-.51.779-.968 1.592-1.425 2.404-.146.259-.572.072-.425-.19z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.489 83.099H49.518a1.01 1.01 0 01-1.011-1.015V1.014A1.018 1.018 0 0149.517 0h86.972a1.013 1.013 0 011.011 1.015v81.07a1.012 1.012 0 01-1.011 1.015z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.489 83.099H49.518a1.01 1.01 0 01-1.011-1.015V1.014A1.018 1.018 0 0149.517 0h86.972a1.013 1.013 0 011.011 1.015v81.07a1.012 1.012 0 01-1.011 1.015zM49.518.405a.606.606 0 00-.606.608v81.071a.61.61 0 00.606.608h86.971a.608.608 0 00.606-.608V1.014a.608.608 0 00-.606-.608H49.518z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.613 21.066a.685.685 0 00-.685.69.69.69 0 00.685.688h37.658a.684.684 0 00.685-.689.688.688 0 00-.685-.689H90.613zm0 4.134a.685.685 0 00-.684.689.69.69 0 00.684.688h19.225a.688.688 0 000-1.378H90.613zM57.7 47.428a.685.685 0 00-.685.689.69.69 0 00.685.688h70.607a.687.687 0 00.485-1.175.688.688 0 00-.485-.202H57.7zm0 4.133a.685.685 0 00-.685.689.69.69 0 00.685.689h52.175a.683.683 0 00.684-.69.691.691 0 00-.684-.688H57.7zm0 4.04a.685.685 0 00-.685.689.69.69 0 00.685.689h70.607a.688.688 0 000-1.378H57.7zm0 4.133a.685.685 0 00-.685.69.69.69 0 00.685.688h52.175a.684.684 0 00.684-.689.683.683 0 00-.684-.689H57.7zm0 4.148a.685.685 0 00-.685.69.69.69 0 00.685.688h70.607a.687.687 0 00.485-1.175.688.688 0 00-.485-.203H57.7zm0 4.134a.685.685 0 00-.685.688.69.69 0 00.685.69h52.175a.683.683 0 00.684-.69.691.691 0 00-.684-.688H57.7z",
    fill: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.883 33.718c-1.95 0-3.856-.58-5.478-1.668a9.89 9.89 0 01-3.631-4.441 9.931 9.931 0 01-.561-5.718 9.909 9.909 0 012.698-5.067 9.826 9.826 0 0110.745-2.145 9.868 9.868 0 014.425 3.644 9.923 9.923 0 011.662 5.499 9.927 9.927 0 01-2.891 6.994 9.853 9.853 0 01-6.969 2.902z",
    fill: "#009996"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.953 71.139a2.48 2.48 0 00-.97-1.853 2.462 2.462 0 00-2.039-.442l-3.259-4.61-3.274 1.305 4.694 6.445a2.486 2.486 0 001.07 1.403 2.47 2.47 0 003.242-.565 2.493 2.493 0 00.536-1.683z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.601 70.797L22.74 57.956 26.435 46.3c.27-2.93 2.098-3.75 2.175-3.783l.119-.05 3.215 8.606-2.36 6.319 5.794 9.782-2.777 3.623z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.849 31.212a2.459 2.459 0 00-1.766 1.115 2.48 2.48 0 00-.281 2.074l-4.328 3.618 1.55 3.175L68.062 36a2.48 2.48 0 001.31-1.18 2.495 2.495 0 00-.811-3.2 2.47 2.47 0 00-1.713-.407z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 37.595L55.008 48.457 43.144 45.66c-2.932-.044-3.886-1.81-3.925-1.884l-.06-.115 8.3-3.883 6.46 1.874 9.268-6.555L67 37.595z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.227 114.81h3.223l1.532-12.475h-4.755v12.475z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.664 117.812l-10.127.001v-3.927l7.285-.001c.754 0 1.477.301 2.01.836.532.534.832 1.26.832 2.016v1.075z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.349 114.81h3.222l1.533-12.475h-4.755v12.475z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.785 117.812l-10.126.001v-3.927l7.285-.001a2.838 2.838 0 012.625 1.761c.143.346.216.716.216 1.091v1.075zM32.203 69.275l.263 18.467.263 24.27 5.782-.528 2.89-33.503 3.68 33.503h5.97l.601-33.767-2.103-7.386-17.346-1.056z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.52 71.755c-6.291 0-12.082-2.857-12.16-2.897l-.065-.032-.528-12.718c-.153-.45-3.168-9.317-3.679-12.136-.517-2.855 6.98-5.362 7.89-5.655l.207-2.297 8.402-.909 1.065 2.94 3.014 1.134a1.493 1.493 0 01.924 1.758l-1.675 6.838 4.092 22.624-.881.038c-2.112.957-4.39 1.312-6.606 1.312z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.617 32.912c2.931-1.608 4.009-5.298 2.406-8.24a6.038 6.038 0 00-8.21-2.416c-2.93 1.609-4.008 5.298-2.406 8.24a6.038 6.038 0 008.21 2.416z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.816 33.463c1.153 1.232 3.294.57 3.444-1.113.012-.131.01-.263-.003-.393-.077-.746-.507-1.423-.404-2.211.023-.196.096-.383.212-.543.918-1.235 3.075.553 3.942-.565.531-.686-.093-1.765.315-2.53.538-1.012 2.133-.513 3.133-1.067 1.113-.616 1.046-2.33.314-3.372-.894-1.271-2.46-1.95-4.007-2.047-1.547-.098-3.083.322-4.527.886-1.64.642-3.267 1.53-4.277 2.977-1.228 1.761-1.346 4.129-.732 6.188.373 1.253 1.648 2.783 2.59 3.79z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.367 117.969H.701a.2.2 0 01-.201-.202.202.202 0 01.201-.202h76.666a.2.2 0 01.201.202.2.2 0 01-.201.202z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.314 27.56a.7.7 0 01-.48-.189l-3.25-3.031a.708.708 0 01.453-1.224.703.703 0 01.505.188l2.754 2.568 5.448-5.47a.705.705 0 11.996 1l-5.928 5.951a.702.702 0 01-.498.207z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_678_36403"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h137v118H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestSuccess);
export default __webpack_public_path__ + "static/media/requestSuccess.a363edd0edd890b99d299041dfd2ff0a.svg";
export { ForwardRef as ReactComponent };